/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const PlusCircle: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="plus-circle" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M642.2175 415.565V642.2174999999999H415.565V717.7824999999999H642.2175V944.435H717.7825V717.7824999999999H944.435V642.2174999999999H717.7825000000001V415.565H642.2175000000001zM1208.87 680C1208.87 972.1025 972.06 1208.8700000000001 679.9999999999999 1208.8700000000001S151.1299999999999 972.06 151.1299999999999 680S387.9399999999999 151.1299999999999 679.9999999999999 151.1299999999999C972.1024999999998 151.1299999999999 1208.87 387.9399999999999 1208.87 680zM1133.3475 680C1133.3475 429.6325000000001 930.3675 226.6524999999999 680 226.6524999999999S226.6525 429.6325 226.6525 680C226.6525 930.3675 429.6325 1133.3475 680 1133.3475S1133.3475 930.3675 1133.3475 680z" : "M513.774 332.452V513.7739999999999H332.452V574.2259999999999H513.774V755.548H574.226V574.2259999999999H755.548V513.7739999999999H574.2260000000001V332.452H513.7740000000001zM967.096 544C967.096 777.682 777.648 967.096 543.9999999999999 967.096S120.9039999999999 777.648 120.9039999999999 544S310.3519999999999 120.9039999999999 543.9999999999999 120.9039999999999C777.6819999999999 120.9039999999999 967.096 310.3519999999999 967.096 544zM906.6780000000002 544C906.6780000000002 343.706 744.2940000000001 181.3219999999999 544 181.3219999999999S181.322 343.7059999999999 181.322 544C181.322 744.294 343.706 906.678 544 906.678S906.6780000000002 744.294 906.6780000000002 544z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
PlusCircle.displayName = `Blueprint5.Icon.PlusCircle`;
export default PlusCircle;
